import { createAction, props } from '@ngrx/store';

import { AgentBaseInfo } from '@agents/models/agent-base-info';
import { ApiError } from '@error/models/api-error';

export const loadAgents = createAction('[Agents] Load Agents');
export const loadAgentsSuccess = createAction('[Agents] Load Agents Success', props<{ agents: AgentBaseInfo[] }>());
export const loadAgentsFailed = createAction('[Agents] Load Agents Failed', (error: ApiError) => error);